var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Zm-4.962-3.787a.937.937 0 0 0-1.35.027l-4.342 5.531-2.616-2.617a.937.937 0 0 0-1.325 1.325l3.308 3.309a.939.939 0 0 0 1.348-.026l4.99-6.237a.938.938 0 0 0-.012-1.313h-.002Z"
  })));
};
export default SvgSuccess;